/**
 * Reglas de negocio compartidas para el cálculo de precios por price_group.
 *
 * Flujo:
 *   cost --(solo LP45, vía dealer profit)--> list_price --(descuentos del price_group)--> tiers
 *
 * Para cualquier price_group que NO sea LP45, el list_price NO se deriva del cost:
 * viene de part_info_local.list_price (poblado por Infoauto/pvp) o, en el
 * calculador standalone del Dashboard, se ingresa directamente.
 */

export const LP45_GROUP_NAME = "LP45";
export const DEFAULT_DEALER_PROFIT = 1.1;

/**
 * Calcula el list_price para el grupo LP45 a partir del cost.
 * Fórmula vigente: list_price = cost * dealerProfit * 2
 */
export function calculateLp45ListPrice(
  cost,
  dealerProfit = DEFAULT_DEALER_PROFIT
) {
  const numericCost = Number(cost) || 0;
  const numericProfit = Number(dealerProfit) || 0;
  return numericCost * numericProfit * 2;
}

/**
 * Aplica los descuentos de un price_group sobre un list_price ya calculado,
 * respetando los mínimos (floor) de cada tier.
 *
 * @param {number} listPrice
 * @param {{retail:number, repairShop:number, wholesale:number}} group
 * @param {{online?:number, repairShop?:number, wholesale?:number}} minPrices
 */
export function calculateTiersFromListPrice(listPrice, group, minPrices = {}) {
  const price = Number(listPrice) || 0;

  const applyDiscount = (discount, minPrice = 0) => {
    const numericDiscount = Number(discount) || 0;
    const computed = price * (1 - numericDiscount);
    return Math.max(computed, Number(minPrice) || 0);
  };

  if (!group) {
    return {
      online: Math.max(0, Number(minPrices.online) || 0),
      repairShop: Math.max(0, Number(minPrices.repairShop) || 0),
      wholesale: Math.max(0, Number(minPrices.wholesale) || 0)
    };
  }

  return {
    online: applyDiscount(group.retail, minPrices.online),
    repairShop: applyDiscount(group.repairShop, minPrices.repairShop),
    wholesale: applyDiscount(group.wholesale, minPrices.wholesale)
  };
}
